var _g, _path, _g2, _path2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_222_6235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8657 8.32948C11.7382 8.82598 11.304 9.19648 10.791 9.45298C9.3367 9.95548 8.18845 10.44 7.23745 10.9095C6.39595 11.3257 6.40495 12.6405 7.2487 13.0507C8.23495 13.53 9.4732 13.9897 10.8487 14.5357C11.2185 14.682 11.7412 15.096 11.871 15.6052C12.2915 17.2221 12.8082 18.8124 13.4182 20.3677C13.884 21.558 15.0367 21.5565 15.5055 20.3677C16.113 18.8235 16.5757 17.1562 17.097 15.57C17.1603 15.3293 17.282 15.1079 17.4513 14.9254C17.6206 14.7429 17.8322 14.605 18.0675 14.5237C19.2645 14.0945 20.4455 13.622 21.6082 13.107C22.5532 12.6907 22.5727 11.34 21.6397 10.8975C20.4708 10.3403 19.2768 9.83755 18.0615 9.39073C17.824 9.30612 17.6096 9.16729 17.4353 8.98528C17.261 8.80326 17.1315 8.58307 17.0572 8.34223C16.4917 6.60973 16.1332 5.13973 15.5317 3.61423C15.063 2.42473 13.8337 2.46148 13.3642 3.65023C12.7657 5.17123 12.348 6.68398 11.8657 8.32948Z",
    fill: "url(#paint0_linear_222_6235)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8657 8.32948C11.7382 8.82598 11.304 9.19648 10.791 9.45298C9.3367 9.95548 8.18845 10.44 7.23745 10.9095C6.39595 11.3257 6.40495 12.6405 7.2487 13.0507C8.23495 13.53 9.4732 13.9897 10.8487 14.5357C11.2185 14.682 11.7412 15.096 11.871 15.6052C12.2915 17.2221 12.8082 18.8124 13.4182 20.3677C13.884 21.558 15.0367 21.5565 15.5055 20.3677C16.113 18.8235 16.5757 17.1562 17.097 15.57C17.1603 15.3293 17.282 15.1079 17.4513 14.9254C17.6206 14.7429 17.8322 14.605 18.0675 14.5237C19.2645 14.0945 20.4455 13.622 21.6082 13.107C22.5532 12.6907 22.5727 11.34 21.6397 10.8975C20.4708 10.3403 19.2768 9.83755 18.0615 9.39073C17.824 9.30612 17.6096 9.16729 17.4353 8.98528C17.261 8.80326 17.1315 8.58307 17.0572 8.34223C16.4917 6.60973 16.1332 5.13973 15.5317 3.61423C15.063 2.42473 13.8337 2.46148 13.3642 3.65023C12.7657 5.17123 12.348 6.68398 11.8657 8.32948Z",
    fill: "url(#paint1_linear_222_6235)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_222_6235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.82578 4.36206C5.78453 4.52181 5.64503 4.64106 5.48003 4.72356C5.01203 4.88556 4.64228 5.04156 4.33628 5.19306C4.06553 5.32656 4.06778 5.74956 4.34003 5.88156C4.65728 6.03606 5.05553 6.18381 5.49803 6.35931C5.61803 6.40656 5.78528 6.54006 5.82803 6.70431C5.95628 7.20906 6.13178 7.74306 6.32528 8.23656C6.47528 8.61981 6.84653 8.61906 6.99728 8.23656C7.19228 7.74006 7.34228 7.20306 7.50953 6.69231C7.52995 6.61479 7.56918 6.5435 7.62373 6.48476C7.67828 6.42603 7.74648 6.38165 7.82228 6.35556C8.20779 6.218 8.58806 6.06614 8.96228 5.90031C9.0306 5.86978 9.08877 5.82035 9.12991 5.75785C9.17106 5.69534 9.19346 5.62237 9.19449 5.54754C9.19551 5.47272 9.17511 5.39916 9.1357 5.33556C9.09628 5.27195 9.03949 5.22094 8.97203 5.18856C8.65103 5.03706 8.25203 4.86081 7.82003 4.70406C7.74374 4.67658 7.67486 4.63181 7.61878 4.57326C7.5627 4.5147 7.52094 4.44395 7.49678 4.36656C7.31453 3.80856 7.19903 3.33606 7.00553 2.84406C6.85553 2.46156 6.45878 2.47356 6.30803 2.85606C6.11528 3.34581 5.98103 3.83256 5.82578 4.36206Z",
    fill: "url(#paint2_linear_222_6235)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82602 4.36206C5.78477 4.52181 5.64527 4.64106 5.48027 4.72356C5.01227 4.88556 4.64252 5.04156 4.33652 5.19306C4.06577 5.32656 4.06802 5.74956 4.34027 5.88156C4.65752 6.03606 5.05577 6.18381 5.49827 6.35931C5.61827 6.40656 5.78552 6.54006 5.82827 6.70431C5.95652 7.20906 6.13202 7.74306 6.32552 8.23656C6.47552 8.61981 6.84677 8.61906 6.99752 8.23656C7.19252 7.74006 7.34252 7.20306 7.50977 6.69231C7.5302 6.61479 7.56942 6.5435 7.62397 6.48476C7.67853 6.42603 7.74672 6.38165 7.82252 6.35556C8.20804 6.218 8.5883 6.06614 8.96252 5.90031C9.03084 5.86978 9.08901 5.82035 9.13016 5.75785C9.1713 5.69534 9.19371 5.62237 9.19473 5.54754C9.19576 5.47272 9.17536 5.39916 9.13594 5.33556C9.09652 5.27195 9.03973 5.22094 8.97227 5.18856C8.65127 5.03706 8.25227 4.86081 7.82027 4.70406C7.74399 4.67658 7.67511 4.63181 7.61902 4.57326C7.56294 4.5147 7.52118 4.44395 7.49702 4.36656C7.31477 3.80856 7.19927 3.33606 7.00577 2.84406C6.85577 2.46156 6.45902 2.47356 6.30827 2.85606C6.11552 3.34581 5.98127 3.83256 5.82602 4.36206Z",
    fill: "url(#paint3_linear_222_6235)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_222_6235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.91966 15.0496C3.86266 15.2723 3.66766 15.4381 3.43741 15.5536C2.78491 15.7786 2.26891 15.9961 1.84216 16.2076C1.46491 16.3943 1.46866 16.9838 1.84741 17.1676C2.28991 17.3836 2.84566 17.5898 3.46291 17.8351C3.62941 17.9003 3.86341 18.0863 3.92191 18.3151C4.10191 19.0186 4.34641 19.7641 4.61641 20.4526C4.82566 20.9866 5.34316 20.9858 5.55316 20.4526C5.82616 19.7596 6.03316 19.0111 6.26716 18.2986C6.29523 18.1903 6.34974 18.0908 6.4258 18.0088C6.50186 17.9269 6.59708 17.8651 6.70291 17.8291C7.24053 17.6369 7.77089 17.425 8.29291 17.1938C8.38794 17.151 8.46879 17.082 8.52597 16.9949C8.58314 16.9078 8.61426 16.8062 8.61568 16.702C8.6171 16.5978 8.58875 16.4953 8.53397 16.4067C8.47919 16.3181 8.40024 16.2469 8.30641 16.2016C7.78192 15.9515 7.2461 15.7261 6.70066 15.5258C6.59407 15.4878 6.49783 15.4254 6.41958 15.3436C6.34133 15.2619 6.28323 15.163 6.24991 15.0548C5.99566 14.2771 5.83516 13.6178 5.56516 12.9323C5.35516 12.3998 4.80241 12.4156 4.59241 12.9496C4.32391 13.6321 4.13566 14.3108 3.91966 15.0496Z",
    fill: "url(#paint4_radial_222_6235)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_222_6235",
    x: 6.31108,
    y: 2.55267,
    width: 16.2048,
    height: 18.8947,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1875,
    dy: -0.1875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.482353 0 0 0 0 0.329412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_222_6235"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1875,
    dy: 0.1875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.737255 0 0 0 0 0.615686 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_222_6235",
    result: "effect2_innerShadow_222_6235"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.3,
    dy: 0.1875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.901961 0 0 0 0 0.458824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_222_6235",
    result: "effect3_innerShadow_222_6235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_222_6235",
    x: 4.05952,
    y: 2.56311,
    width: 5.21006,
    height: 6.0356,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.075,
    dy: 0.075
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.803922 0 0 0 0 0.6 0 0 0 0 0.262745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_222_6235"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.075,
    dy: 0.075
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.882353 0 0 0 0 0.423529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_222_6235",
    result: "effect2_innerShadow_222_6235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_222_6235",
    x: 1.56128,
    y: 12.4284,
    width: 7.16694,
    height: 8.42438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1125,
    dy: -0.1125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.458824 0 0 0 0 0.462745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_222_6235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_6235",
    x1: 19.5967,
    y1: 8.45323,
    x2: 11.289,
    y2: 17.1982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_6235",
    x1: 11.0655,
    y1: 21.9675,
    x2: 15.594,
    y2: 12.4155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF886D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF886D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_6235",
    x1: 8.31428,
    y1: 4.40181,
    x2: 5.64053,
    y2: 7.21656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A967"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_222_6235",
    x1: 6.66452,
    y1: 8.98506,
    x2: 6.66452,
    y2: 5.89131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA071",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_222_6235",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.51066 13.9253) rotate(127.221) scale(5.30699 5.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#FFBC64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.b5ac8738d5015e9b10bbd8a6bf0a1e1f.svg";
export { ForwardRef as ReactComponent };